<template>

  <div class="container-fluid">

    <div class="row">
        <div class="col-sm-12 col-lg-12 mt-3">
            <div class="card">
                <div class="card-header">
                    <h5><vue-feather type="map-pin"></vue-feather> Región Portal México Verde</h5>
                </div>
                    
                <div class="card-body">
                    <h5>La transición hacia una economía verde no ocurre en abstracto: <b>ocurre en el territorio.</b></h5>
                    <p>La sección Región Portal México Verde te permite conocer cómo cada estado está avanzando en el reverdecimiento de sus sectores estratégicos.</p>
                    <p>Aquí encontrarás:</p>
                    <img src="@/assets/images/verde/opciones-estatales-2.png" class="img-fluid mb-3" style="max-width: 80%; display: block; margin-left: auto; margin-right: auto;" />
                    <p></p>
                    <p>El Bajío es una de las regiones más dinámicas del país. Esta sección te permite entender dónde están las oportunidades reales y cómo alinearte con la visión territorial.</p>
                    <p>📍 Selecciona tu estado y descubre cómo integrarte a su Hoja de Ruta.</p>
                    <p>🤝 La transición es regional: participa, articula y suma.</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Estado de carga -->
    <div v-if="loading" class="text-center py-5">
      <div class="loader-box">
        <div class="loader-3"></div>
      </div>
      <p>Cargando...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="text-center py-5">
      <div class="alert alert-danger">
        <h5>Error al cargar los datos</h5>
        <p>{{ error.message || 'Ocurrió un error inesperado' }}</p>
        <button class="btn btn-primary" @click="fetchPosts()">Reintentar</button>
      </div>
    </div>

    <!-- Contenido cuando hay datos -->
    <div v-else-if="estados != null">
      
      <!-- Tarjetas con los documentos obtenidos del request -->
      <div class="row starter-main">

        <div class="col-sm-12 col-lg-4" v-for="post in estados" :key="post.id">
          <div class="card">
            <router-link :to="{ name: 'fichaEstatal', params: { idestado: post.id } }">
              <img
                v-if="post.thumbnail_rendition"
                :src="post.thumbnail_rendition.full_url"
                :alt="post.thumbnail_rendition.alt"
                class="card-img-top"
                style="object-fit: contain; max-height: 160px; padding: 1rem; cursor: pointer;"
              />
            </router-link>
            <div class="card-body">
              <h5 class="text-center">{{ post.title }}</h5>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import api from "@/axios";

export default {
  name: "BajioVerdeIntro",
  data() {
    return {
      estados: null,
      error: null,
      loading: true,
    };
  },
  created() {
    this.fetchPosts();
  },
  methods: {
    async fetchPosts() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await api.get("blog?child_of=24&fields=intro,thumbnail,thumbnail_rendition&order=first_published_at");
        this.estados = data.items ?? (Array.isArray(data) ? data : [data]);
      } catch (err) {
        this.error = err;
        console.error("error en fetchPosts", err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
